import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrAttachmentIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M9.7684 1.71745C10.2954 1.23991 10.9859 0.983335 11.6969 1.00084C12.4079 1.01835 13.0849 1.30859 13.5878 1.81149C14.0907 2.31439 14.381 2.99142 14.3985 3.70241C14.416 4.4134 14.1594 5.10389 13.6819 5.63092C13.6759 5.63756 13.6697 5.64407 13.6634 5.65045L7.04061 12.3666C7.03223 12.3751 7.02362 12.3834 7.01478 12.3914C6.69073 12.685 6.26619 12.8428 5.82904 12.832C5.3919 12.8212 4.97563 12.6428 4.66643 12.3336C4.35723 12.0244 4.17877 11.6081 4.16801 11.171C4.15724 10.7338 4.315 10.3093 4.60861 9.98522C4.61444 9.97879 4.62039 9.97248 4.62648 9.9663L10.1822 4.31724C10.4286 4.06666 10.8315 4.0633 11.0821 4.30974C11.3327 4.55618 11.336 4.95909 11.0896 5.20966L5.54506 10.8474C5.47512 10.9283 5.43771 11.0325 5.44035 11.1396C5.44307 11.2502 5.4882 11.3554 5.56638 11.4336C5.64457 11.5118 5.74983 11.5569 5.86037 11.5597C5.96627 11.5623 6.06924 11.5258 6.14975 11.4574L12.7469 4.76723C12.9998 4.48348 13.1355 4.11403 13.1261 3.73373C13.1167 3.34935 12.9598 2.98333 12.6879 2.71145C12.416 2.43956 12.05 2.28265 11.6656 2.27318C11.2866 2.26385 10.9185 2.39854 10.6351 2.64971L4.026 9.35202L4.02286 9.35518C3.54256 9.83548 3.27273 10.4869 3.27273 11.1662C3.27273 11.8454 3.54256 12.4968 4.02286 12.9771C4.50316 13.4574 5.15459 13.7273 5.83384 13.7273C6.51309 13.7273 7.16452 13.4574 7.64482 12.9771L13.121 7.51428C13.3698 7.26607 13.7728 7.26656 14.021 7.51538C14.2692 7.7642 14.2687 8.16712 14.0199 8.41533L8.54477 13.8771C7.82579 14.5961 6.85064 15 5.83384 15C4.81704 15 3.84189 14.5961 3.12291 13.8771C2.40392 13.1581 2 12.183 2 11.1662C2 10.1501 2.4033 9.17571 3.12125 8.45689L9.74257 1.74221C9.75095 1.73372 9.75956 1.72546 9.7684 1.71745Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrAttachmentIconComponent;
